import type { FlowAnswer } from '@neuroedge/shared';

/**
 * Read-only list of the extra `COLLECT_TEXT` questions a conversation flow
 * asked before creating this booking/order/lead (date of birth, birth
 * place, delivery address, etc.) - lets staff see them inline instead of
 * opening the raw chat history. Renders nothing when `metadata.answers` is
 * empty/absent (flows with no `COLLECT_TEXT` step never populate it).
 */
export function FlowAnswersList({ metadata }: { metadata: Record<string, unknown> | undefined }) {
  const answers = Array.isArray(metadata?.answers) ? (metadata!.answers as FlowAnswer[]) : [];
  if (answers.length === 0) return null;

  return (
    <dl style={{ margin: 0, display: 'flex', flexDirection: 'column' }}>
      {answers.map((a, i) => (
        <div
          key={a.key}
          style={{
            padding: 'var(--space-3) 0',
            borderTop: i === 0 ? undefined : '1px solid var(--color-border)',
          }}
        >
          <dt style={{ fontWeight: 600 }}>{a.label}</dt>
          <dd
            style={{
              margin: 'var(--space-1) 0 0',
              color: 'var(--color-text-muted)',
            }}
          >
            {a.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
